module.exports = {"tags":"Tags","category":"Category","outlet":"Outlet"};